<template>
<div>
  <v-layout>
    <div class="flex md7">
      <v-select ref="paraedit" :items="items" v-model="paraBirimi" item-value="text" item-text="text" label="Para Birimi" hide-details v-on:input="paraBirimiChange()"></v-select>
    </div>
    <div class="flex md5">

      <v-text-field ref="kuredit" hide-details label="Kur" v-model="kur" v-on:change="kurChange()">
      </v-text-field>
    </div>

  </v-layout>

</div>
</template>

<script>
import tool from "../tools";

var store = {
  debug: true,
  okunuyor: false,
  state: {
    paraBirimleri: []
  },
  setParaBirimleri(newValue) {
    console.log("setMessageAction triggered with", newValue);
    this.state.paraBirimleri = newValue;
  }
};

export default {
  components: {},
  props: ["value", "kurtarihi"],

  computed: {
    model: {
      get: function () {
        this.watchmodel(this.value);
        return this.value;
      },
      set: function (newValue) {
        this.$emit("input", newValue);
      }
    }
  },
  data() {
    return {
      items: [],
      defitems: [{
          text: "TL"
        },
        {
          text: "USD"
        },
        {
          text: "AUD"
        },
        {
          text: "DKK"
        },
        {
          text: "EUR"
        },
        {
          text: "GBP"
        },
        {
          text: "CHF"
        },
        {
          text: "SEK"
        },
        {
          text: "CAD"
        },
        {
          text: "KWD"
        },
        {
          text: "NOK"
        },
        {
          text: "SAR"
        },
        {
          text: "JPY"
        },
        {
          text: "BGN"
        },
        {
          text: "RON"
        },
        {
          text: "RUB"
        },
        {
          text: "IRR"
        },
        {
          text: "CNY"
        },
        {
          text: "PKR"
        },
        {
          text: "QAR"
        }
      ],
      kurList: [],
      paraBirimi: null,
      kur: 1,
      fkurtarihi: null,
    };
  },

  created: function () {},

  watch: {
    model(val) {
      this.watchmodel(val);
    }
  },

  methods: {
    kurChange: kurChange,
    paraBirimiChange: paraBirimiChange,
    paraAra: paraAra,
    paraAraTL: paraAraTL,
    getKur: getKur,
    watchmodel: watchmodel,
  }
};

function watchmodel(val) {

  if ((store.state.paraBirimleri.length == 0) || (store.okunuyor == false)) {
    store.okunuyor = true;
    tool
      .http_post(this, "ParaBirimleri", {
        paraBirimi: "",
        kur: "",
        kurTarihi: null
      })
      .then(
        response => {
          if (response.body.length == 0) {
            this.items = this.defitems;
          } else {
            this.items = response.body;
            console.log("db gitti");
          }
          store.setParaBirimleri(this.items);
          this.kur = val.kur;
          this.paraBirimi = val.paraBirimi;
        },
        response => {
          this.items = this.defitems;
          this.kur = val.kur;
          this.paraBirimi = val.paraBirimi;
        }
      );
  } else {
    this.items = store.state.paraBirimleri;

    this.kur = val.kur;
    this.paraBirimi = val.paraBirimi;
  }

}

function paraAra(paraBirimi) {
  return paraBirimi.paraBirimi == this.paraBirimi;
}

function paraAraTL(paraBirimi) {
  return paraBirimi.paraBirimi == "TL";
}

function kurChange() {
  this.model.kur = this.kur;
}

function paraBirimiChange() {

  if (this.model.paraBirimi !== this.paraBirimi) {
    this.model.paraBirimi = this.paraBirimi;
  }
  if (this.fkurtarihi == null || this.kurtarihi != this.fkurtarihi) {
    this.fkurtarihi = this.kurtarihi;

    if (this.fkurtarihi == null)
      this.fkurtarihi = tool.Now_yyyy_MM_dd();

    tool.http_post(this, "KurAra", {
      tarih: this.fkurtarihi
    }).then(
      response => {
        this.kurList = response.body;
        this.getKur();
      },
      response => {
        this.model.kur = 1;
      }
    );
  } else {
    this.getKur();

  }
}

function getKur() {
  var p = this.kurList.find(this.paraAra);

  if (p == undefined) {
    this.model.kur = 1;
  } else {
    this.model.kur = p.kur;
  }

}
</script>
